import ModuloMenu from './ModuloMenu';

export default ModuloMenu;